import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    code: yup.string().typeError(errors.REQUIRED).required(errors.REQUIRED),
    label: yup.string(),
  });
};

export default validation;
